export class QuestionTypes {
    "SINGLE_SELECT":string="single-select";
    "SINGLE_SELECT_DROPDOWN":string="single-select-dropdown";
    "OPEN_END":string="open-end";
    "MULTI_SELECT":string="multi-select";
    "MULTIPLE_CHOICE_SINGLE":string="multiple-choice-single";
    "MULTIPLE_CHOICE_MULTI_SELECT":string="multiple-choice-multiple-select";
    "COUNTER_TYPE":string="counter-type";
    "COMPLETE":string="complete"
}
